import React, { useState } from 'react';
import {
  Anchor,
  bffService,
  Button,
  config,
  H4,
  H5,
  InputSelect,
  Paragraph,
  useForm,
  validation,
  Wrapper,
} from '@thisisdevelopment/akzonobel-core';
import { ContainerInner, InputField, Page } from '@thisisdevelopment/heritage-core-library';
import { CallUs, ContactUsWrapper, MessageSent, SendAMessage } from '@/pages/ContactUs/styled';
import form from '@/pages/ContactUs/form.json';
import NextHead from '@/components/NextHead';
import metas from '@/routes/meta';

function ContactUs() {
  const [isMessageSent, setIsMessageSent] = useState<boolean>(false);
  const initialValues = {
    name: '',
    email: '',
    reason: '',
    query: '',
    orderNumber: '',
    productRef: '',
  };
  const formValidation = {
    name: [validation.required],
    email: [validation.required, validation.email],
    reason: [validation.required],
    query: [validation.required],
  };
  const { bindInput, handleSubmit } = useForm(initialValues, formValidation);

  const reasonOptions = form.formData
    .find(({ id }) => id === 'reason')
    ?.options?.map(({ optionDesc, id }) => ({ value: id, label: optionDesc }));

  const sendContact = async (values: any) => {
    const payload = {
      ...form,
      siteCode: config.domainCode,
      formData: form.formData.map((field) => ({
        ...field,
        values: [values[field.id]],
      })),
    };
    await bffService.sendContact(payload);
    setIsMessageSent(true);
  };

  const meta = metas.default;

  return (
    <div>
      <NextHead meta={meta} />
      <Page title="Contact Us">
        <ContainerInner>
          <ContactUsWrapper>
            {!isMessageSent && (
              <SendAMessage>
                <H4 mb="20px">Send us a message</H4>
                <InputField label="Name" mb="20px" {...bindInput('name')} autoFocus />
                <InputField label="E-mail" mb="20px" type="email" {...bindInput('email')} />
                <InputField label="Phone number" mb="20px" {...bindInput('telephone')} />
                {reasonOptions && (
                  <InputSelect
                    label="Reason"
                    mb="20px"
                    options={[...reasonOptions]}
                    placeholder="Select the reason"
                    {...bindInput('reason')}
                  />
                )}
                <InputField
                  label="Order Number - if applicable"
                  mb="20px"
                  {...bindInput('orderNumber')}
                />
                <InputField
                  label="Product Name / Barcode / Batch Number - if applicable"
                  mb="20px"
                  {...bindInput('productRef')}
                />
                <InputField
                  textArea
                  label="Your message"
                  height="130px"
                  mb="40px"
                  {...bindInput('query')}
                />
                <Button color="secondary" width="200px" onClick={() => handleSubmit(sendContact)}>
                  Send
                </Button>
              </SendAMessage>
            )}
            {isMessageSent && (
              <MessageSent>
                <H4 mb="20px">Thank you!</H4>
                Your message was submitted successfully.
              </MessageSent>
            )}
            <CallUs>
              <H5>Call us</H5>
              <Paragraph>
                For Customer Service and Product Advice on{' '}
                <Anchor href="tel:0333 222 7878">0333 222 7878</Anchor>
              </Paragraph>
              <Paragraph fontWeight="extrabold" mb="0">
                Open between
              </Paragraph>
              <Paragraph mt="5px">
                8:30am - 5:00pm Monday to Friday
                <br />
                9:00am - 12:30pm Saturday
              </Paragraph>
              <H5 mb="16px" mt="32px">
                Send us an e-mail
              </H5>
              <Paragraph>
                <Anchor href="mailto:duluxheritage@akzonobel.com">
                  duluxheritage@akzonobel.com
                </Anchor>
              </Paragraph>
              <H5 mb="16px" mt="32px">
                Write to us
              </H5>
              <Wrapper as="address">
                Dulux Customer Care Centre
                <br /> Wexham Road
                <br /> Slough
                <br /> SL2 5DS
                <br /> United Kingdom
              </Wrapper>
            </CallUs>
          </ContactUsWrapper>
        </ContainerInner>
      </Page>
    </div>
  );
}

export default ContactUs;
